import { Box, VStack, chakra, keyframes, useColorModeValue, Stack, useToast } from '@chakra-ui/react';
import Header from '../../../../components/Header/Header';
import CardHeaderMobile from '../../../../components/Mobile/header';
import HeaderSectionMobilePage from '../../../../components/Mobile/headerSection';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRequestGetDataToRegistration } from '../../../../services/hooks/CandidateArea/useGetDataToRegistration';
import LabelWithValueMobilePage from '../../../../components/Mobile/labelWithValue';
import { useRequestGetSpecialCondition } from '../../../../services/hooks/SpecialCondition/useGetSpecialCondition';
import RegistrationSpecialConditionMobilePage from '../../Registration/Mobile/specialCondition';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { validadeFileName, validateTypeFile, validationSizeFile } from '../../../../utils/validationForm';
import { useGetRegistration } from '../../../../services/hooks/Registration/useGetRegistration';
import NavigationButtonMobilePage from '../../../../components/Mobile/navigationButton';
import { useRequestUpdateSpecialCondition } from '../../../../services/hooks/SpecialCondition/usePatchSpecialCondition';
import { useEffect } from 'react';
import { UseRegistration } from '../../../../Store/useRegistration';

const floatIn = keyframes`
  from { opacity: 0; transform: translateY(18px) scale(0.995); }
  to   { opacity: 1; transform: translateY(0px) scale(1); }
`;
const AnimatedBox = chakra(Box, {
  baseStyle: {
    animation: `${floatIn} 420ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

const SpecialConditionUpdateMobilePage: React.FC = () => {
  const registrationId = useLocation().pathname.split('/')[3];
  const selectiveProcessId = useLocation().pathname.split('/')[4];

  const { setSelectiveProcessId, onResetRegistration, setRegistrationId } = UseRegistration();

  const navigate = useNavigate();
  const toast = useToast();

  const selectiveProcessData = useRequestGetDataToRegistration(selectiveProcessId);
  const specialConditionData = useRequestGetSpecialCondition(registrationId || '');
  const registrationData = useGetRegistration(registrationId);
  const patchSpecialCondition = useRequestUpdateSpecialCondition();

  const bgGradient = useColorModeValue('linear(to-br, gray.50, white)', 'linear(to-br, gray.900, gray.800)');
  const borderColor = useColorModeValue('gray.100', 'gray.700');

  const validate = Yup.object().shape({
    has_special_condition: Yup.string().required('O campo é obrigatorio'),
    observation: Yup.array(),
    attachmentFile: Yup.array(),
    selectedSpecialCondition: Yup.array()
      .test('isRequired', 'Selecione ao menos um atendimento especial', function (specialConditionList) {
        let isEmpty = false;
        const { has_special_condition } = this.parent;
        if (!(has_special_condition === 'yes')) return true;

        specialConditionList?.forEach((modality) => {
          if (modality !== false) {
            isEmpty = true;
            return;
          }
        });

        return isEmpty;
      })
      .test('isRequired', '', function (specialConditionList) {
        const { has_special_condition, observation: obs } = this.parent;
        if (!(has_special_condition === 'yes')) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modality, index) => {
          if (modality !== false) {
            const observation: string = obs[index];
            if (observation?.length === 0) {
              if (!selectiveProcessData.data?.special_condition[index].is_social_name) {
                validationError.push(
                  new Yup.ValidationError('Campo Obrigatorio', specialConditionList[index], `observation.${index}`),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }

        return true;
      })
      .test('isRequired', 'Campo obrigatório', function (specialConditionList) {
        const { attachmentFile } = this.parent;

        if (registrationId) {
          const validationError: Yup.ValidationError[] = [];

          specialConditionList?.forEach((modality, index) => {
            const specialConditionDataToRegistration = selectiveProcessData.data?.special_condition.find(
              (sp) => sp.id === modality,
            );

            if (modality !== false) {
              const file: FileList = attachmentFile[index];
              const spc = registrationData.data?.special_conditions.find((sp) => sp?.id === modality);
              if (spc?.attachments && spc?.attachments?.length > 0) {
                if (file?.length === 0 && registrationData.data?.special_conditions[index]?.attachments?.length === 0) {
                  if (specialConditionDataToRegistration?.has_attachment) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Selecione um arquivo para continuar',
                        specialConditionList[index],
                        `attachmentFile.${index}`,
                      ),
                    );
                  } else {
                    return true;
                  }
                }

                return true;
              } else if (file?.length === 0 && specialConditionDataToRegistration?.has_attachment) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    specialConditionList.filter((sp) => sp !== false)[index],
                    `attachmentFile.${index}`,
                  ),
                );
                return;
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }

        if (!registrationId) {
          const validationError: Yup.ValidationError[] = [];
          specialConditionList?.forEach((modality, index) => {
            const specialConditionDataToRegistration = selectiveProcessData.data?.special_condition.find(
              (sp) => sp.id === modality,
            );
            if (modality !== false) {
              const file: FileList = attachmentFile[index];
              if (file?.length === 0 && specialConditionDataToRegistration?.has_attachment) {
                validationError.push(
                  new Yup.ValidationError(
                    'Selecione um arquivo para continuar',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          });
          if (validationError?.length > 0) {
            throw new Yup.ValidationError(validationError);
          }
          return true;
        }
      })
      .test('TypeFile', 'Tipo de arquivo nao suportado', function (specialConditionList) {
        const { attachmentFile } = this.parent;
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = attachmentFile[index];
            if (file?.length > 0) {
              const response = validateTypeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tipo de arquivo nao suportado',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFileSize', '', function (specialConditionList) {
        const { attachmentFile } = this.parent;
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];
        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const file: FileList = attachmentFile[index];
            if (file?.length > 0) {
              const response = validationSizeFile(file);
              if (!response) {
                validationError.push(
                  new Yup.ValidationError(
                    'Tamanho máximo para arquivos é de 2MB',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('MaxFile', 'Quantidade maxima de arquivos atingida (5)', function (specialConditionList) {
        const { attachmentFile } = this.parent;
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = attachmentFile[index];
            if (attach && attach?.length > 0) {
              registrationData.data?.special_conditions.forEach((value) => {
                if (value.id === modalityListFile) {
                  const file = value?.attachments?.length || 0;
                  if (file > 4) {
                    validationError.push(
                      new Yup.ValidationError(
                        'Quantidade maxima de arquivos atingida (5)',
                        specialConditionList[index],
                        `attachmentFile.${index}`,
                      ),
                    );
                  }
                }
              });
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      })
      .test('FileName', 'Nome de arquivo invalido', function (specialConditionList) {
        const { attachmentFile } = this.parent;
        if (!specialConditionList || (specialConditionList && specialConditionList.length === 0)) return true;

        const validationError: Yup.ValidationError[] = [];

        specialConditionList?.forEach((modalityListFile, index) => {
          if (modalityListFile !== false) {
            const attach = attachmentFile[index];
            if (attach?.length > 0) {
              const file = validadeFileName(attach);

              if (!file) {
                validationError.push(
                  new Yup.ValidationError(
                    'Nome do arquivo invalido',
                    specialConditionList[index],
                    `attachmentFile.${index}`,
                  ),
                );
              }
            }
          }
        });
        if (validationError.length > 0) {
          throw new Yup.ValidationError(validationError);
        }
        return true;
      }),
  });

  const listCheckedSpecialCondition: (string | boolean)[] = [];
  const listObservationSpecialCondition: (string | boolean | undefined)[] = [];

  selectiveProcessData.data?.special_condition.map((s) => {
    let isSelected = false;
    let obs = '';
    // let sName = '';

    registrationData.data?.special_conditions.forEach((r) => {
      if (r.id === s.id) {
        isSelected = true;
        obs = r.observations;
        // sName = r?.social_name;
      }
    });

    if (isSelected) {
      listCheckedSpecialCondition.push(s.id);
      listObservationSpecialCondition.push(obs);
      // listSocialName.push(sName);
    } else {
      listCheckedSpecialCondition.push(false);
      listObservationSpecialCondition.push('');
      // listSocialName.push(undefined);
    }
  });

  const hookForms = useForm({
    resolver: yupResolver(validate),
    values: {
      has_special_condition:
        (registrationData.data?.special_conditions &&
          (registrationData.data.special_conditions.length > 0 ? 'yes' : 'no')) ||
        '',
      selectedSpecialCondition: listCheckedSpecialCondition,
      observation: listObservationSpecialCondition,
    },
  });

  useEffect(() => {
    setRegistrationId(registrationId);
    setSelectiveProcessId(selectiveProcessId);

    return () => {
      onResetRegistration();
    };
  }, []);

  const newSpecialCondition = async (data: FieldValues) => {
    patchSpecialCondition
      .mutateAsync({
        data: data,
        registrationId: registrationId || '',
        specialCondition: specialConditionData?.data?.special_conditions,
      })
      .then(() => {
        toast({
          title: 'Sucesso',
          description: 'Condições especiais alteradas com sucesso',
          status: 'success',
          duration: 4000,
          isClosable: true,
        });
        navigate('/painel/inscricoes');
      })
      .catch(() => {
        toast({
          title: 'Erro',
          description: 'Erro na solicitação, tente novamente mais tarde',
          status: 'error',
          duration: 4000,
          isClosable: true,
        });
      });
  };

  return (
    <Stack as="form" h="100dvh" onSubmit={hookForms.handleSubmit(newSpecialCondition)}>
      <Stack height="calc(100% - 40px)" w="100%" top={0} bg="white" gap={0}>
        <Header />
        <VStack mt={0} mx={3} flex={1} overflowY="auto" py={2}>
          <AnimatedBox
            bgGradient={bgGradient}
            borderRadius="lg"
            boxShadow="lg"
            p={{ base: 5, md: 10 }}
            borderWidth={'1px'}
            borderColor={borderColor}
            w="full"
            display="flex"
          >
            <VStack boxSizing="border-box" flex={1} spacing={6} align="stretch">
              <CardHeaderMobile
                title="Atendimento especial"
                subTitle="Proteja sua conta com uma senha forte — nunca compartilhe com ninguém."
              />
              <Stack>
                <HeaderSectionMobilePage>{selectiveProcessData.data?.name}</HeaderSectionMobilePage>
                <LabelWithValueMobilePage label="Inscrição" value={specialConditionData?.data?.registration_code} />
                <LabelWithValueMobilePage label="Nome" value={specialConditionData?.data?.candidate} />
                <LabelWithValueMobilePage
                  label={selectiveProcessData.data?.is_cultural_house ? 'Turma' : 'Vaga/Cargo'}
                  value={specialConditionData?.data?.selective_process_vacancy}
                />
                <LabelWithValueMobilePage label="Modalidade" value={specialConditionData?.data?.type_of_competition} />
              </Stack>
              <FormProvider {...hookForms}>
                <RegistrationSpecialConditionMobilePage
                  specialCondition={selectiveProcessData.data?.special_condition || []}
                />
              </FormProvider>
            </VStack>
          </AnimatedBox>
        </VStack>
      </Stack>
      <NavigationButtonMobilePage
        absolute
        mainButtonText="Atualizar"
        typeButton="submit"
        isLoading={patchSpecialCondition.isPending}
        loadingText="Salvando..."
        goBackButtonText="Voltar"
        onGoBackButton={() => navigate(-1)}
      />
    </Stack>
  );
};

export default SpecialConditionUpdateMobilePage;
